// 把一棵树拍扁
const flattenTree = node => {
  if (node.children && node.children.length) {
    let item = JSON.parse(JSON.stringify(node))
    delete item.children
    let result = [item]
    for (const child of node.children) {
      result = result.concat(flattenTree(child))
    }
    return result
  }
  return node
}

// 为选择器重新格式化选项
const normalizerPropertyOption = item => {
  item.value = item.id
  item.label = item.name
  delete item.id
  delete item.name
  item.customProperties = {}
  if (item['拼音']) {
    item.customProperties['pinyin'] = item['拼音']
    delete item['拼音']
  }
  if (item['拼音首字母']) {
    item.customProperties['pinyin_abbr'] = item['拼音首字母']
    delete item['拼音首字母']
  }
  return item
}

// getBreadcrumb
function getBreadcrumb(id, array, breadcrumb) {
  for (let i = 0; i < array.length; i++) {
    let item = array[i]
    breadcrumb.push(item)
    if (item.id === id) {
      return breadcrumb
    }
    if (Array.isArray(item.children)) {
      let result = getBreadcrumb(id, item.children, breadcrumb)
      if (result !== false) {
        return result
      }
    }
    breadcrumb.pop()
  }
  return false
}

function isObjectEquals(x, y) {
  if (x === y) return true
  // if both x and y are null or undefined and exactly the same

  if (!(x instanceof Object) || !(y instanceof Object)) return false
  // if they are not strictly equal, they both need to be Objects

  if (x.constructor !== y.constructor) return false
  // they must have the exact same prototype chain, the closest we can do is
  // test there constructor.

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue
    // other properties were tested using x.constructor === y.constructor

    if (!y.hasOwnProperty(p)) return false
    // allows to compare x[ p ] and y[ p ] when set to undefined

    if (x[p] === y[p]) continue
    // if they have the same strict value or identity then they are equal

    if (typeof (x[p]) !== 'object') return false
    // Numbers, Strings, Functions, Booleans must be strictly equal

    if (!isObjectEquals(x[p], y[p])) return false
    // Objects and Arrays must be tested recursively
  }

  for (p in y) {
    if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false
    // allows x[ p ] to be set to undefined
  }
  return true
}

export {
  flattenTree,
  normalizerPropertyOption,
  getBreadcrumb,
  isObjectEquals
}


// WEBPACK FOOTER //
// ./src/core/util.js